<template>
  <div class="col-xs-12">
    <div class="col-xs-12 col-md-3 p-10 text-center border" v-if="show.category">
      <h4 class="text-red">停賣分類</h4>
      <div class="col-xs-12">
        <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
          <tbody>
          <tr class="even" role="row" v-for="(category, index) in disTableList.category">
            <td>
              {{index + 1}}
            </td>
            <td>
              {{category.name}}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="col-xs-12 col-md-3 p-10 text-center border" v-if="show.product">
      <h4 class="text-red">停賣商品</h4>
      <div class="col-xs-12">
        <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
          <tbody>
          <tr class="even" role="row" v-for="(product, index) in disTableList.product">
            <td>
              {{index + 1}}
            </td>
            <td>
              {{product.name}}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="col-xs-12 col-md-3 p-10 text-center border" v-if="show.adjust">
      <h4 class="text-red">停賣調整類別</h4>
      <div class="col-xs-12">
        <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
          <tbody>
          <tr class="even" role="row" v-for="(adjust, index) in disTableList.adjust">
            <td>
              {{index + 1}}
            </td>
            <td>
              {{adjust.name}}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="col-xs-12 col-md-3 p-10 text-center" v-if="show.option">
      <h4 class="text-red">停賣調整項目</h4>
      <div class="col-xs-12">
        <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
          <tbody>
          <tr class="even" role="row" v-for="(option, index) in disTableList.option">
            <td>
              {{index + 1}}
            </td>
            <td>
              {{option.name}}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="col-xs-12 col-md-3 p-10 text-center border" v-if="show.combination">
      <h4 class="text-red">停賣組合</h4>
      <div class="col-xs-12">
        <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
          <tbody>
          <tr class="even" role="row" v-for="(combination, index) in disTableList.combination">
            <td>
              {{index + 1}}
            </td>
            <td>
              {{combination.name}}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
export default{
  props: ['storeId'],
  data () {
    return {
      disTableList: {
        category: [],
        product: [],
        adjust: [],
        option: [],
        combination: []
      },
      show: {
        category: false,
        product: false,
        adjust: false,
        option: false,
        combination: false
      }
    }
  },
  methods: {
    getDisItemList () {
      this.disTableList = []
      this.show = {
        category: false,
        product: false,
        adjust: false,
        option: false,
        combination: false
      }
      var self = this
      var url = '/store/' + this.storeId + '/disableItemList'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.disTableList = response.data.item_list
          if (self.disTableList.category.length) self.show.category = true
          if (self.disTableList.product.length) self.show.product = true
          if (self.disTableList.adjust.length) self.show.adjust = true
          if (self.disTableList.option.length) self.show.option = true
          if (self.disTableList.combination.length) self.show.combination = true
        }
      })
    }
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    }
  },
  watch: {
    storeId () {
      this.getDisItemList()
    }
  }
}
</script>
<style lang="sass" scoped>
.border
  border: 1px solid #eeeeee
</style>



// WEBPACK FOOTER //
// DisItemTableTemp.vue?42ec5d02